var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7.625a.5.5 0 0 1 .5.5v3.75a.5.5 0 0 1-1 0v-3.75a.5.5 0 0 1 .5-.5m.375 5.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0",
    clipRule: "evenodd"
  })));
});
const SvgCircleAlertsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleAlertsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNiAxMUM4LjQ4NTI4IDExIDEwLjUgOC45ODUyOCAxMC41IDYuNUMxMC41IDQuMDE0NzIgOC40ODUyOCAyIDYgMkMzLjUxNDcyIDIgMS41IDQuMDE0NzIgMS41IDYuNUMxLjUgOC45ODUyOCAzLjUxNDcyIDExIDYgMTFaTTYgMy4zNzVDNi4yNzYxNCAzLjM3NSA2LjUgMy41OTg4NiA2LjUgMy44NzVWNy42MjVDNi41IDcuOTAxMTQgNi4yNzYxNCA4LjEyNSA2IDguMTI1QzUuNzIzODYgOC4xMjUgNS41IDcuOTAxMTQgNS41IDcuNjI1VjMuODc1QzUuNSAzLjU5ODg2IDUuNzIzODYgMy4zNzUgNiAzLjM3NVpNNi4zNzUgOS4xMjVDNi4zNzUgOS4zMzIxMSA2LjIwNzExIDkuNSA2IDkuNUM1Ljc5Mjg5IDkuNSA1LjYyNSA5LjMzMjExIDUuNjI1IDkuMTI1QzUuNjI1IDguOTE3ODkgNS43OTI4OSA4Ljc1IDYgOC43NUM2LjIwNzExIDguNzUgNi4zNzUgOC45MTc4OSA2LjM3NSA5LjEyNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+Cg==";